import { render, staticRenderFns } from "./FollowsListModal.vue?vue&type=template&id=4822fe75&scoped=true"
import script from "./FollowsListModal.vue?vue&type=script&lang=ts"
export * from "./FollowsListModal.vue?vue&type=script&lang=ts"
import style0 from "./FollowsListModal.vue?vue&type=style&index=0&id=4822fe75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822fe75",
  null
  
)

export default component.exports